import React from "react";

import { Info } from "lucide-react";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../intelligence-briefing-library/components/ui/tooltip";

const infoIconClass =
  "inline-flex h-3.5 w-3.5 shrink-0 cursor-pointer items-center justify-center rounded-full border border-gray-200 bg-gray-50 text-gray-400 transition-colors hover:border-purple-300 hover:bg-purple-50 hover:text-purple-600 focus:outline-none focus-visible:border-purple-400 focus-visible:text-purple-600 data-[state=open]:border-purple-300 data-[state=open]:bg-purple-50 data-[state=open]:text-purple-600";

const tooltipClass =
  "z-[9999] max-w-[320px] border border-gray-200 bg-white px-3 py-2.5 text-[12.5px] font-normal normal-case tracking-normal leading-relaxed text-gray-800 shadow-[0_4px_16px_rgba(0,0,0,0.12)]";

type InfoTipProps = {
  /** Accessible name for the info control (e.g. section title). */
  label: string;
  /** Optional bold heading inside the tip. */
  title?: string;
  /** Tip body text. */
  body: string;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
};

/** Circular (i) control with white info tip — shared AL / settings pattern. */
const InfoTip: React.FC<InfoTipProps> = ({
  label,
  title,
  body,
  side = "bottom",
  align = "start",
}) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <button
        type="button"
        className={infoIconClass}
        aria-label={`About ${label}`}
      >
        <Info className="h-2 w-2" strokeWidth={2.5} aria-hidden />
      </button>
    </TooltipTrigger>
    <TooltipContent
      side={side}
      align={align}
      sideOffset={8}
      className={tooltipClass}
    >
      {title ? (
        <p className="mb-0.5 font-semibold text-gray-900">{title}</p>
      ) : null}
      <p className="mb-0 text-[12.5px] leading-snug text-gray-800">{body}</p>
    </TooltipContent>
  </Tooltip>
);

export default InfoTip;
